//#Global Imports
import React from "react";
import clsx from "clsx";
// import Countdown, { zeroPad } from "react-countdown";
//#end Global Imports

//#Local Imports
import OtpBox from "../../../../components/ui/OtpBox";
import Typograpy from "../../../../components/ui/Typography";
import Button from "../../../../components/ui/Button";
import TextField from "../../../../components/ui/TextField";
import ErrorField from "../../../../components/ui/ErrorField";
import {
  PassportIcon,
  ReloadIcon,
  UploadIcon,
  // InfoIcon,
  // ArrowRight,
  // WarningIconRound,
} from "../../../../assets/Icons";
import IUserDocuments from "../../userDocuments";
//#end Local Imports

const AadharCardSection: React.FC<IUserDocuments.IAadharCardSectionProps> = ({
  adharCardDetails,
  handleDeleteDoc,
  handleChangeUpload,
  entityId,
  saveAdharOTPValue,
  adharOTPError,
  handleVerifyAdharCard,
  buttonLoader,
  // sendAdharOtp,
  // dateKey,
  // date,
}) => {
  return (
    <div className="col-span-4 lg:pl-10 lg:pt-7">
      <div className="w-full">
        <Typograpy
          tagType="div"
          className="mb-5 text-base font-medium text-black"
          text="Upload Aadhaar Card"
        />
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-primary-350"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor:
                  adharCardDetails.isAadharDocVerified || adharCardDetails.isAadharDocUploaded
                    ? "border-success-150"
                    : "border-none",
                borderRadius: "rounded",
              }}
              className="w-full lg:w-[48%] mb-5 h-[68px]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      adharCardDetails.isAadharDocVerified || adharCardDetails.isAadharDocUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload Aadhaar Card</div>
                </div>
                <div className="flex items-center space-x-4">
                  {!adharCardDetails.isAadharDocVerified &&
                    (adharCardDetails.isAadharDocUploaded ? (
                      <div
                        onClick={
                          adharCardDetails.isAadharDocUploaded &&
                            !adharCardDetails.isAadharDocVerified
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor={"fill-primary"} width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor={"fill-black"} />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {adharCardDetails.uploadedDocError !== "" && (
            <ErrorField errorMessage={adharCardDetails.uploadedDocError} />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="AADHAR_CARD"
              type="file"
              disabled={adharCardDetails.isAadharDocUploaded}
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => {
                handleChangeUpload(e, "AADHAR_CARD");
              }}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              // id="sfkdj902d987-dskdkiksw"
              bgColor="bg-primary-350"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderColor: adharCardDetails.uploadedBackError
                  ? "border-error border"
                  : adharCardDetails.isAadharBackUploaded
                    ? "border-success border"
                    : "border-none",
                borderRadius: "rounded",
              }}
              className={clsx(
                adharCardDetails.uploadedBackError ? "" : "mb-5",
                "w-full lg:w-[48%] h-[68px]",
              )}
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      adharCardDetails.isAadharBackUploaded ? "fill-success-150" : "fill-primary"
                    }
                  />
                  <div>Upload Aadhaar Back</div>
                </div>
                <div className="flex items-center space-x-4">
                  {/* {adharCardDetails.isAadharBackUploaded && !isPDFfile && (
                    <div
                      className="z-50 cursor-pointer"
                      onClick={() => {
                        handlePreviewUploadedDoc("AADHAR_CARD_BACK");
                      }}
                    >
                      <VisibilityOnIcon fillColor="fill-black-150" />
                    </div>
                  )} */}
                  {adharCardDetails.isAadharBackUploaded && (
                    <div className="z-50 cursor-pointer" onClick={handleDeleteDoc}>
                      <ReloadIcon
                        fillColor={
                          adharCardDetails?.uploadedBackError ? "fill-error" : "fill-primary"
                        }
                        width="24"
                        height="24"
                      />
                    </div>
                  )}
                  {!adharCardDetails.isAadharBackUploaded && (
                    <UploadIcon
                      fillColor={
                        adharCardDetails.isAadharBackUploaded ? "fill-success-150" : "fill-black"
                      }
                    />
                  )}
                </div>
              </div>
            </Button>
          </div>
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="AADHAR_CARD_BACK"
              type="file"
              // disabled={adharCardDetails.isAadharDocUploaded}
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => {
                handleChangeUpload(e, "AADHAR_CARD_BACK");
              }}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <Typograpy
          tagType="div"
          className="mb-5 text-sm font-bold text-black lg:text-base font-lato"
          text="Aadhaar Card No"
        />
        <div className="flex flex-col items-center lg:items-start lg:w-3/4 lg:flex-row">
           <TextField
            name="adharNo"
            type="text"
            inputClasses={clsx(
              adharCardDetails.isAadharDocVerified ? "border-success-150" : "border-grey-150",
              "border !pt-0",
            )}
            value={adharCardDetails?.isAadharDocUploaded ? adharCardDetails.aadharNumber : ""}
            errorMessage={adharCardDetails.messageAadhar}
            error={adharCardDetails.messageAadhar !== ""}
            disabled={!adharCardDetails?.isAadharDocVerified}
            // fullWidth
            pattern="[a-zA-Z0-9 ]{1,}"
          />
          {/* {!adharCardDetails.isAadharDocVerified && (
            <Button
              bgColor={
                adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded
                  ? "bg-primary"
                  : "bg-grey-450"
              }
              fontStyle={{
                fontFamily: "",
                fontSize: "text-base",
                fontWeight: "font-bold",
                fontColor:
                  adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded
                    ? "text-white"
                    : "text-black-650",
              }}
              className="w-full py-5 mt-10 lg:ml-6 lg:w-1/2 lg:mt-0"
              disabled={
                !adharCardDetails.isAadharDocUploaded || !adharCardDetails.isAadharBackUploaded
              }
              isLoading={buttonLoader.aadhaarOtpLoader}
              onClickHandler={sendAdharOtp}
            >
              {entityId === "" ? (
                "Send OTP"
              ) : (
                <div className={clsx("flex flex-col items-center sm:justify-center justify-end")}>
                  <div>
                    <Countdown
                      key={dateKey}
                      date={date}
                      renderer={({ minutes, seconds, completed }) => {
                        if (completed) {
                          return (
                            <div
                              className="text-xs font-bold text-black cursor-pointer font-lato"
                              onClick={() => ""}
                            >
                              Resend OTP
                            </div>
                          );
                        } else {
                          return (
                            <div className="flex items-center justify-center p-1 space-x-2 rounded">
                              <div
                                className="font-bold text-white cursor-pointer font-lato"
                                onClick={() => ""}
                              >
                                Resend OTP
                              </div>
                              <div className={"text-white"}>
                                {zeroPad(minutes)} :{zeroPad(seconds)}
                              </div>
                            </div>
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </Button>
          )} */}
        </div>
        {/* {Boolean(adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded) && (
          <div className="mt-[10%]">
            <div className="flex items-center justify-start">
              <WarningIconRound />
              <span className="ml-4">An OTP will be sent to your registered mobile no.</span>
            </div>
            <div className="flex items-center justify-start mt-5">
              <WarningIconRound />
              <span className="ml-4">Mobile No. is not linked with Aadhaar? </span>
              <div onClick={handleVerifyAdharCard} className="flex items-center justify-center">
                <span className="ml-2 mr-2 text-blue-500 font-medium">Click here to continue</span>
                <ArrowRight />
              </div>
            </div>
          </div>
        )} */}
        {adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded && (
          <div className="flex flex-col items-center justify-between my-8 w-full">
            {/* <div className="flex items-center justify-start w-full">
              <InfoIcon fillColor="fill-grey-950" />
              <Typograpy
                tagType="div"
                text="Mobile No. is not linked with Aadhaar?"
                className="ml-3 mr-2 text-base font-normal text-grey-550"
              />
            </div> */}
            {/* <p className="underline underline-offset-4 text-base text-primary"> */}
            {/* Click here to continue. */}
            {/* </p> */}
            <div className="flex w-full justify-start">
              <Button
                bgColor={
                  adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded
                    ? "bg-primary"
                    : "bg-grey-450"
                }
                fontStyle={{
                  fontFamily: "",
                  fontSize: "text-base",
                  fontWeight: "font-bold",
                  fontColor:
                    adharCardDetails.isAadharDocUploaded && adharCardDetails.isAadharBackUploaded
                      ? "text-white"
                      : "text-black-650",
                }}
                borderStyle={{
                  borderWidth: "border-none",
                  borderRadius: "rounded-full lg:rounded",
                }}
                className={`${adharCardDetails?.isAadharDocVerified ? "hidden" : "py-5 w-4/5 m-auto lg:mx-0 mt-9 lg:!w-[24%]"}`}
                disabled={
                  !adharCardDetails.isAadharDocUploaded || !adharCardDetails.isAadharBackUploaded
                }
                onClickHandler={handleVerifyAdharCard}
                isLoading={buttonLoader.aadhaarOtpLoader}
              >
                Verify
              </Button>
            </div>
          </div>
        )}
        {!adharCardDetails.isAadharDocVerified && (
          <div className={clsx(entityId === "" ? "hidden" : "block", "mt-12")}>
            <Typograpy
              tagType="div"
              className="mb-8 text-sm font-bold text-black font-lato"
              text="Verify your Aadhar OTP"
            />
            <div className="flex flex-col items-center justify-between lg:w-3/4 lg:flex-row">
              <OtpBox
                numberOfBoxes={6}
                updateValue={(value) => saveAdharOTPValue(value)}
                errorMsg={adharOTPError ?? ""}
                otpBoxClassName={clsx(
                  adharOTPError === "" ? "border-none" : "border",
                  "bg-primary-350 !w-[52px] !mr-2",
                )}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AadharCardSection;
